// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__WJAhU","icon":"link_icon__1z1ze","iconOnly":"link_iconOnly__1NHge","notifMarker":"link_notifMarker__MjnrT","loading":"link_loading__1iKmH"};